module.exports = __webpack_public_path__ + "images/backgrounds/city/medium.a7eea5e35c08388ec3da.jpg";